module.exports = __webpack_public_path__ + "img/invite-logo.2dbc6610.png";